import { SnackBarData } from "../external/ensolvers-core-frontend-mui/types/SnackbarData";

export const sendSnackBarMessage = (snackData: SnackBarData) => {
  const customEvent = new CustomEvent("snackMessage", {
    detail: { snackData },
  });
  document.dispatchEvent(customEvent);
};
